
//For more google voices go to https://cloud.google.com/text-to-speech/docs/voices

import { Voice, VoiceEngine } from "../core/types/guide"
import us from '../assets/svgs/flag_us'
import uk from '../assets/svgs/flag_uk'
import aus from '../assets/svgs/flag_aus'
import ca from '../assets/svgs/flag_ca'
import ind from '../assets/svgs/flag_in'


type Accent =  "American" | "Australian" | "British" | "Canadian" | "Spanish (ESP)" | "Indonesian" | "Hindi" | "Indian"

export type FrontendVoice = {
    displayName: string, 
    description?: string,
    gender: "male"|"female"|"neutral", 
    accent: Accent,
    sample?:string,
    engine: VoiceEngine, 
    id: string, 
}

export const googleVoices : { [key: string]: FrontendVoice } = {
    "en-US-Neural2-J": {
        displayName: "Pete", 
        description: "Clueso recommended",
        gender: "male", 
        accent: "American", 
        engine: "google", 
        id: "en-US-Neural2-J",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/Google_4_voice.mp3"
    },
    "en-US-Studio-M": {
        displayName: "Brian", 
        description: "Clueso recommended",
        gender: "male", 
        accent: "American", 
        engine: "google", 
        id: "en-US-Studio-M",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/en-US-Studio-M.wav"
    },
    "en-US-Studio-O": {
        displayName: "Sofia", 
        description: "Clueso recommended",
        gender: "female", 
        accent: "American", 
        engine: "google", 
        id: "en-US-Studio-O",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/en-US-Studio-O.wav"
    },
    "en-US-Polyglot-1": {
        displayName: "Georgie", 
        description: "Clueso recommended",
        gender: "male", 
        accent: "American", 
        engine: "google", 
        id: "en-US-Polyglot-1",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/en-US-Polyglot-1.wav"
    },
    "en-US-Neural2-F": {
        displayName: "Google 1", 
        description: "Neutral robotic",
        gender: "female", 
        accent: "American", 
        engine: "google", 
        id: "en-US-Neural2-F",
    }, 
    "en-US-Neural2-A": {
        displayName: "Google 2", 
        description: "Neutral robotic",
        gender: "male", 
        accent: "American", 
        engine: "google", 
        id: "en-US-Neural2-A",
    }, 
    "en-AU-Neural2-C": {
        displayName: "Google 3", 
        description: "Neutral robotic",
        gender: "female", 
        accent: "Australian", 
        engine: "google", 
        id: "en-AU-Neural2-C",
    },
    
    "en-GB-Neural2-D": {
        displayName: "Google 5", 
        description: "Neutral robotic",
        gender: "male", 
        accent: "British", 
        engine: "google", 
        id: "en-GB-Neural2-D",
    }
}

export const voicesForeign : { [key: string]: FrontendVoice } = {
    "es-ES-Polyglot-1": {
        displayName: "Juan", 
        description: "Deep",
        gender: "male", 
        accent: "Spanish (ESP)", 
        engine: "google", 
        id: "es-ES-Polyglot-1",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/es-ES-Polyglot-1.wav"
    },
    "es-ES-Neural2-D": {
        displayName: "Stefania", 
        description: "Deep",
        gender: "female", 
        accent: "Spanish (ESP)", 
        engine: "google", 
        id: "es-ES-Neural2-D",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/es-ES-Neural2-D.wav"
    },
    "id-ID-Wavenet-C": {
        displayName: "Aditya", 
        description: "Deep",
        gender: "male", 
        accent: "Indonesian", 
        engine: "google", 
        id: "id-ID-Wavenet-C",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/id-ID-Wavenet-C.wav"
    },
    "id-ID-Standard-C": {
        displayName: "Farel", 
        description: "Deep",
        gender: "male", 
        accent: "Indonesian", 
        engine: "google", 
        id: "id-ID-Standard-C",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/id-ID-Standard-C.mp3"
    },
    "hi-IN-Wavenet-C":{
        displayName: "Rahul",
        description: "Calm",
        gender: "male", 
        accent: "Hindi", 
        engine: "google", 
        id: "hi-IN-Wavenet-C",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/hi-IN-Wavenet-C.wav"
    },
    "hi-IN-Neural2-D": {
        displayName: "Shruti",
        description: "Calm",
        gender: "female", 
        accent: "Hindi", 
        engine: "google", 
        id: "hi-IN-Neural2-D",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/hi-IN-Neural2-D.wav"
    }
}

export const playVoices: { [key: string]: FrontendVoice } = {
    
    "s3://peregrine-voices/donna_parrot_saad/manifest.json": {
        displayName: "Donna",
        description: "Enthusiastic, fast", 
        accent: "American", 
        gender: "female", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/donna+narrative.wav",
        engine: "play", 
        id: "s3://peregrine-voices/donna_parrot_saad/manifest.json"
    }, 
    "s3://mockingbird-prod/william_vo_narrative_0eacdff5-6243-4e26-8b3b-66e03458c1d1/voices/speaker/manifest.json":{
        displayName: "William",
        description: "Slow, deep", 
        accent: "American", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.us-east-1.amazonaws.com/editor-samples/william_vo_narrative.wav",
        engine: "play", 
        id: "s3://mockingbird-prod/william_vo_narrative_0eacdff5-6243-4e26-8b3b-66e03458c1d1/voices/speaker/manifest.json"

    },
    "s3://peregrine-voices/hudson saad parrot/manifest.json":{
        displayName: "Hudson", 
        description: "Smooth, thick", 
        accent: "American", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/hudson.wav",
        engine: "play", 
        id: "s3://peregrine-voices/hudson saad parrot/manifest.json",
    },
    "s3://peregrine-voices/russell2_parrot_saad/manifest.json":{
        displayName: "Russell", 
        description: "Slow, smooth, narrative", 
        accent: "Australian", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/russell.wav",
        engine: "play", 
        id: "s3://peregrine-voices/russell2_parrot_saad/manifest.json",
    },
    "s3://voice-cloning-zero-shot/418a94fa-2395-4487-81d8-22daf107781f/george/manifest.json":{
        displayName: "George", 
        description: "Enthusiastic", 
        accent: "British", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/george.wav",
        engine: "play", 
        id: "s3://voice-cloning-zero-shot/418a94fa-2395-4487-81d8-22daf107781f/george/manifest.json",
    },
    "s3://voice-cloning-zero-shot/820da3d2-3a3b-42e7-844d-e68db835a206/sarah/manifest.json":{
        displayName: "Sarah", 
        description: "Slow, heavy", 
        accent: "British", 
        gender: "female", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/sarah.wav",
        engine: "play", 
        id: "s3://voice-cloning-zero-shot/820da3d2-3a3b-42e7-844d-e68db835a206/sarah/manifest.json",
    },
    "s3://voice-cloning-zero-shot/028a32d4-6a79-4ca3-a303-d6559843114b/chris/manifest.json":{
        displayName: "Chris", 
        description: "Conversational, natural", 
        accent: "American", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/chris.wav",
        engine: "play", 
        id: "s3://voice-cloning-zero-shot/028a32d4-6a79-4ca3-a303-d6559843114b/chris/manifest.json",
    },
    "s3://peregrine-voices/evelyn 2 saad parrot/manifest.json": {
        displayName: "Evelyn", 
        description: "Enthusiastic, high-pitched", 
        gender: "female", 
        accent: "American", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/evelyn.wav",
        engine: "play",
        id: "s3://peregrine-voices/evelyn 2 saad parrot/manifest.json",
    }, 
    "s3://peregrine-voices/larry_ads3_parrot_saad/manifest.json": {
        displayName: "Larry", 
        description: "Soft marketing", 
        accent: "American", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/larry.wav",
        engine: "play",
        id: "s3://peregrine-voices/larry_ads3_parrot_saad/manifest.json",
    },
    
    "s3://peregrine-voices/oliver_narrative2_parrot_saad/manifest.json": {
        displayName: "Oliver",
        description: "Enthusiastic instructor", 
        accent: "British", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/oliver+narrative.wav",
        engine: "play", 
        id: "s3://peregrine-voices/oliver_narrative2_parrot_saad/manifest.json"
    }, 
    "s3://peregrine-voices/arthur ads parrot saad/manifest.json":{
        displayName: "Arthur", 
        description: "Enthusiastic marketing", 
        accent: "British", 
        gender: "male", 
        sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/arthur.wav",
        engine: "play", 
        id: "s3://peregrine-voices/arthur ads parrot saad/manifest.json",
    },
    "s3://voice-cloning-zero-shot/801a663f-efd0-4254-98d0-5c175514c3e8/jennifer/manifest.json":{
        displayName: "Jennifer", 
        description: "Slow, older", 
        accent: "American", 
        gender: "female", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/jennifer.wav",
        engine: "play", 
        id: "s3://voice-cloning-zero-shot/801a663f-efd0-4254-98d0-5c175514c3e8/jennifer/manifest.json",
    },
   
    "s3://voice-cloning-zero-shot/d9ff78ba-d016-47f6-b0ef-dd630f59414e/female-cs/manifest.json":{
        displayName: "Ruby", 
        description: "Fast, neutral", 
        accent: "British", 
        gender: "female", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/ruby.wav",
        engine: "play", 
        id: "s3://voice-cloning-zero-shot/d9ff78ba-d016-47f6-b0ef-dd630f59414e/female-cs/manifest.json",
    },
    "s3://peregrine-voices/olivia_ads3_parrot_saad/manifest.json":{
        displayName: "Olivia", 
        description: "Neutral, sharp", 
        accent: "Canadian", 
        gender: "female", 
        sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/olivia+narrative.wav",
        engine: "play", 
        id: "s3://peregrine-voices/olivia_ads3_parrot_saad/manifest.json",
    },
    "en-IN-Neural2-B": {
        displayName: "Raj", 
        description: "Fast, enthusiastic",
        gender: "male", 
        accent: "Indian", 
        engine: "google", 
        id: "en-IN-Neural2-B",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/en-IN-Neural2-B.wav"
    },
    "en-IN-Neural2-C": {
        displayName: "Aditya", 
        description: "Fast, enthusiastic",
        gender: "male", 
        accent: "Indian", 
        engine: "google", 
        id: "en-IN-Neural2-C",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/en-IN-Neural2-C.wav"
    },
    "en-IN-Neural2-D": {
        displayName: "Lakshmi", 
        description: "Fast, enthusiastic",
        gender: "female", 
        accent: "Indian", 
        engine: "google", 
        id: "en-IN-Neural2-D",
        sample: "https://clueso-public-assets.s3.ap-south-1.amazonaws.com/voice-samples/en-IN-Neural2-D.wav"
    },
    // "s3://peregrine-voices/charlotte ads parrot saad/manifest.json":{
    //     displayName: "Charlotte", 
    //     description: "Neutral, sharp", 
    //     accent: "Canadian", 
    //     gender: "female", 
    //     sample: "https://peregrine-samples.s3.amazonaws.com/parrot-samples/charlotte+ads.wav",
    //     engine: "play", 
    //     id: "s3://peregrine-voices/charlotte ads parrot saad/manifest.json",
    // },



    // "lottie": {
    //     displayName: "Lottie", 
    //     description: "Slow instructor", 
    //     accent: "British", 
    //     gender: "female", 
    //     sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/Lottie.wav",
    //     engine: "play",
    //     id: "lottie",
    // }, 
    
    // "aurora": {
    //     displayName: "Aurora", 
    //     description: "Soft instructor", 
    //     accent: "British", 
    //     gender: "female", 
    //     sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/Aurora.wav",
    //     engine: "play",
    //     id: "aurora",
    // },
    // "lillian": {
    //     displayName: "Lillian", 
    //     description: "Slow instructor", 
    //     accent: "British", 
    //     gender: "female", 
    //     sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/Lillian.wav",
    //     engine: "play",
    //     id: "lillian",
    // }, 
    
    // "mickey": {
    //     displayName: "Madelyn", 
    //     description: "Mellow narrator", 
    //     accent: "British", 
    //     gender: "female", 
    //     sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/mickey.wav",
    //     engine: "play",
    //     id: "mickey",
    // }, 
    // "florencio": {
    //     displayName: "Madison", 
    //     description: "Very slow instructor (Irish)", 
    //     accent: "British", 
    //     gender: "female", 
    //     sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/florencio.wav",
    //     engine: "play",
    //     id: "florencio",
    // }, 
    // "phoebe": {
    //     displayName: "Phoebe", 
    //     description: "Mellow instructor", 
    //     accent: "British", 
    //     gender: "female", 
    //     sample: "https://peregrine-samples.s3.amazonaws.com/editor-samples/Phoebe.wav",
    //     engine: "play",
    //     id: "phoebe",
    // }, 

}

export const premiumVoices = Object.entries(playVoices).map(([key, value]) => ({ ...value }))
export const basicVoices = Object.entries(googleVoices).map(([key, value]) => ({ ...value }))
export const foreignVoices = Object.entries(voicesForeign).map(([key, value]) => ({ ...value }))

export const allVoices =  [
    ...Object.entries(playVoices).map(([key, value]) => ({ ...value, id:key })), 
    ...Object.entries(googleVoices).map(([key, value]) => ({ ...value, id:key })),
];

export const getBackendVoice : (frontendVoice: FrontendVoice) => Voice = (frontendVoice) =>{
    const {lang, code} = getFlag(frontendVoice.accent)
    
    return {
        engine: frontendVoice.engine, 
        code: frontendVoice.id, 
        language: `${lang}-${code}`
    }
}

export const getFrontendVoice = (voice: Voice) =>{
    const defaultVoice = googleVoices["en-US-Neural2-J"]

    return googleVoices[voice.code] || playVoices[voice.code] || voicesForeign[voice.code] || defaultVoice
    
}

export const getFlag: (accent: Accent) => {lang: string, code: string, flag?:JSX.Element } = (accent: Accent ) =>{

    if(accent==="American") return {lang: "en", code: "US", flag: us()}
    else if(accent==="Australian") return {lang: "en",code: "AU", flag: aus()}
    else if(accent==="British") return {lang: "en",code: "GB", flag: uk()}
    else if(accent==="Canadian") return {lang: "en",code: "CA", flag: ca()}
    else if(accent==="Indian") return {lang: "en", code: "IN", flag: ind()}
    else if (accent==="Spanish (ESP)") return {lang: "es", code: "es"}
    else if (accent ==="Indonesian") return {lang: "id", code: "id"}
    else if (accent === "Hindi") return {lang: "hi", code: "IN"}
    else return {lang: "en", code: "US", flag: us()}

}